import {
	handleResponse,
	handleError,
	MEGAQMART_API_URL as API_URL
} from './apiUtils';

export const saveEmail = async (email) => {
	return fetch(API_URL, {
		method: 'POST',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ email })
	})
		.then(handleResponse)
		.catch(handleError);
};
